<template>
    <div v-if="compare && compare.current" class="stl-hh-compare">
        <div class="stl-hh-compare-cards">
            <!-- 사용량 카드 -->
            <div class="stl-hh-ccard">
                <div class="stl-hh-ccard-lbl">사용량</div>
                <div class="stl-hh-ccard-val">{{ fmtUsage(compare.current.usageQty) }}</div>
                <div class="stl-hh-ccard-rows">
                    <div class="stl-hh-ccard-row">
                        <span class="k">전월</span>
                        <span class="v">{{ prevMonth ? fmtUsage(prevMonth.usageQty) : '—' }}</span>
                        <span v-if="usageDelta(prevMonth) != null" class="d" :class="deltaCls(usageDelta(prevMonth))">{{ fmtPct(usageDelta(prevMonth)) }}</span>
                    </div>
                    <div class="stl-hh-ccard-row">
                        <span class="k">전년동월</span>
                        <span class="v">{{ prevYear ? fmtUsage(prevYear.usageQty) : '—' }}</span>
                        <span v-if="usageDelta(prevYear) != null" class="d dim" :class="deltaCls(usageDelta(prevYear))">{{ fmtPct(usageDelta(prevYear)) }}</span>
                    </div>
                </div>
            </div>

            <!-- 청구합계 카드 -->
            <div class="stl-hh-ccard" :class="{ 'stl-hh-ccard--na': !compare.current.billingAvailable }">
                <div class="stl-hh-ccard-lbl">청구 합계</div>
                <div v-if="compare.current.billingAvailable" class="stl-hh-ccard-val">{{ fmtWon(compare.current.totalAmount) }}원</div>
                <div v-else class="stl-hh-ccard-val stl-hh-ccard-val--na">확정 전</div>
                <div v-if="compare.current.billingAvailable" class="stl-hh-ccard-rows">
                    <div class="stl-hh-ccard-row">
                        <span class="k">전월</span>
                        <span class="v">{{ prevMonth ? fmtWon(prevMonth.totalAmount) + '원' : '—' }}</span>
                        <span v-if="amountDelta(prevMonth) != null" class="d" :class="deltaCls(amountDelta(prevMonth))">{{ fmtPct(amountDelta(prevMonth)) }}</span>
                    </div>
                    <div class="stl-hh-ccard-row">
                        <span class="k">전년동월</span>
                        <span class="v">{{ prevYear ? fmtWon(prevYear.totalAmount) + '원' : '—' }}</span>
                        <span v-if="amountDelta(prevYear) != null" class="d dim" :class="deltaCls(amountDelta(prevYear))">{{ fmtPct(amountDelta(prevYear)) }}</span>
                    </div>
                </div>
                <div v-else class="stl-hh-ccard-na-note">계산·확정 후 금액 비교가 표시됩니다.</div>
            </div>
        </div>
    </div>
    <div v-else class="stl-empty" style="padding: 24px 0"><p>비교 데이터가 없습니다.</p></div>
</template>

<script>
import { fmtWon, fmtUsage, fmtPct } from "../utils/settlementFormat.js";

export default {
    name: "HouseholdCompareSnippet",
    props: {
        compare: { type: Object, default: null },
    },
    computed: {
        prevMonth() {
            return this.compare?.compare?.prevMonth ?? this.compare?.prevMonth ?? null;
        },
        prevYear() {
            return this.compare?.compare?.prevYearSameMonth ?? this.compare?.prevYear ?? null;
        },
    },
    methods: {
        fmtWon,
        fmtUsage,
        fmtPct,
        usageDelta(block) {
            if (!block) return null;
            const v = block.usageDeltaPct ?? block.deltaUsagePct;
            return v != null ? v : null;
        },
        amountDelta(block) {
            if (!block) return null;
            const v = block.amountDeltaPct ?? block.deltaAmountPct;
            return v != null ? v : null;
        },
        deltaCls(pct) {
            if (pct > 0) return "up";
            if (pct < 0) return "down";
            return "";
        },
    },
};
</script>
